<template>
    <div>
        <div class="w1200">
            <div class="title mt20">
                <div class="title-text">产品介绍</div>
                <div class="sub-title f14 mt10">Product introduction</div>
            </div>
            <!-- 产品介绍 -->
            <div class="product mt20">
                <div class="product-list">
                <div class="product-list-item" v-for="(item,index) in productList" :key="index">
                    <div class="mb10 ftb">{{item.name}}</div>
                    <img class="mt20 mb10" :src="item.url" alt="">
                    <div class="sub-title f12 mt20 mb20">
                    <p v-for="(child, idx) in item.subText" :key="idx">{{child}}</p>
                    </div>
                    <div v-if="item.btn" class="mt20 downloadbtn" @click="downloadExe()">
                        <!--<a href="http://www.geeshu.com/fileuploads/offline/SetupGeeShu.exe">aaaaaaaaa</a>-->
                        {{item.btn}}
                    </div>
                </div>
                </div>
            </div>
            <div class="vedio mt20">
                <el-row :gutter="20">
                    <el-col :span="14">
                        <el-carousel height="400px" ref="carousel" direction="vertical" :autoplay="false" indicator-position="none"
                        @setActiveItem="setActiveItem">
                            <el-carousel-item v-for="(item, idx) in videoList" :key="idx" name="idx">
                                <vedio-player-self :path="imgBaseAddress+item.filePath" />
                            </el-carousel-item>
                        </el-carousel>
                    </el-col>
                    <el-col :span="10">
                        <div class="pt10" style="overflow-y:auto;height: 400px;box-sizing:border-box">
                            <div v-for="(item, index) in videoList" :key="index"
                             class="video-label mb20"
                             @click="setActiveItem(index)">
                                <el-row :gutter="10" type="flex" align="middle">
                                    <el-col :span="10">
                                        <div class="video-label-poster">
                                            <el-image :src="imgBaseAddress+item.filePaths" style="width:100%;height:100%"></el-image>
                                            <div class="f12 video-label-poster-time">{{item.videoLength}}</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="14">
                                        <div class="f16 ellipsis">{{item.title}}</div>
                                        <div class="f14 mt20"><!--{{item.createDate}}--></div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="mt20 pb40">
                <el-row :gutter="20">
                <el-col :span="8">
                    <div class="introduction">
                    <div class="introduction-img">
                        <img src="../../../static/img/4.0.2/icon-introduction01.png" alt="">
                    </div>
                    <div class="ftb f20 introduction-title">我们能做什么</div>
                    <div class="sub-title mt20">
                        以新媒体的手段创新了传统书法教育的内容和形式，从根本上解决了“没有老师教”和“不知道怎么教”的问题。
                    </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="introduction">
                    <div class="introduction-img">
                        <img src="../../../static/img/4.0.2/icon-introduction02.png" alt="">
                    </div>
                    <div class="ftb f20 introduction-title">极书是什么</div>
                    <div class="sub-title mt20">
                        极书是基于云服务的书法交互教育平台，平台由正恩联合中国科学技术大学科技传播系与北京师范大学中国传统文化研究传播中心等团队倾心打造。
                    </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="introduction">
                    <div class="introduction-img">
                        <img src="../../../static/img/4.0.2/icon-introduction03.png" alt="">
                    </div>
                    <div class="ftb f20 introduction-title">我们的优势</div>
                    <div class="sub-title mt20">
                        独创结构解析、例字分析、行笔动画、书写视频、碑帖欣赏、汉字六体演变、知识漫画和动画七步教学法。
                    </div>
                    </div>
                </el-col>
                </el-row>
            </div>
            </div>
            <!-- 经典案例 -->
            <div class="case pt20 mt20 pb20">
            <div class="case-content w1200">
                <div class="title">
                <div class="title-text">经典案例</div>
                <div class="sub-title f14 mt10">case</div>
                </div>
                <div class="case-list mt20">
                <el-row :gutter="10">
                    <el-col :span="6">
                    <div class="case-img case-img-type1" ><!--@click="info(imgBaseAddress+caseList[0].id)"-->
                        <el-image :src="imgBaseAddress+caseList[0].filePath" style="width:100%;height:100%;display: block"></el-image>
                        <div class="case-img-title">
                            <div class="f16">{{caseList[0].title}}</div>
                            <div class="f14 ellipsis">{{caseList[0].shortContent}}</div>
                        </div>
                    </div>
                    <div class="mt10 case-img case-img-type2">
                        <el-image :src="imgBaseAddress+caseList[1].filePath" style="width:100%;height:100%;display: block"></el-image>
                        <div class="case-img-title">
                            <div class="f16">{{caseList[1].title}}</div>
                            <div class="f14 ellipsis">{{caseList[1].shortContent}}</div>
                        </div>
                    </div>
                    </el-col>
                    <el-col :span="12">
                    <el-row :gutter="10">
                        <el-col :span="12">
                        <div class="case-img case-img-type3">
                            <el-image :src="imgBaseAddress+caseList[2].filePath" style="width:100%;height:100%;display: block"></el-image>
                            <div class="case-img-title">
                                <div class="f16">{{caseList[2].title}}</div>
                                <div class="f14 ellipsis">{{caseList[2].shortContent}}</div>
                            </div>
                        </div>
                        </el-col>
                        <el-col :span="12">
                        <div class="case-img case-img-type3">
                            <el-image :src="imgBaseAddress+caseList[3].filePath" style="width:100%;height:100%;display: block"></el-image>
                            <div class="case-img-title">
                                <div class="f16">{{caseList[3].title}}</div>
                                <div class="f14 ellipsis">{{caseList[3].shortContent}}</div>
                            </div>
                        </div>
                        </el-col>
                    </el-row>
                    <div class="case-img case-img-type4 mt10">
                        <el-image :src="imgBaseAddress+caseList[4].filePath" style="width:100%;height:100%;display: block"></el-image>
                        <div class="case-img-title">
                            <div class="f16">{{caseList[4].title}}</div>
                            <div class="f14 ellipsis">{{caseList[4].shortContent}}</div>
                        </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                    <div class="case-img case-img-type2">
                        <el-image :src="imgBaseAddress+caseList[5].filePath" style="width:100%;height:100%;display: block"></el-image>
                        <div class="case-img-title">
                            <div class="f16">{{caseList[5].title}}</div>
                            <div class="f14 ellipsis">{{caseList[5].shortContent}}</div>
                        </div>
                    </div>
                    <div class="mt10 case-img case-img-type1">
                        <!--<img :src="imgBaseAddress+caseList[6].filePath" :onerror="defaultImg">-->
                        <el-image :src="imgBaseAddress+caseList[6].filePath" style="width:100%;height:100%;display: block"></el-image>
                        <div class="case-img-title">
                            <div class="f16">{{caseList[6].title}}</div>
                            <div class="f14 ellipsis">{{caseList[6].shortContent}}</div>
                        </div>
                    </div>
                    </el-col>
                </el-row>
                </div>
            </div>
            </div>
            <!-- 底部导航 -->
            <footer-nav>
              <div class="data-top">
                <div class="data-title ftb">开启智慧教育时代</div>
                <div class="data-subtitle mt10">您的痛点，我们帮您解决</div>
                </div>
                <div class="mt20 pt20 pb20 mb20">
                <el-row type="flex" justify="space-between">
                    <el-col :span="6">
                    <div>
                        <span class="data-info ftb">100</span>
                        <span>%</span>
                    </div>
                    <div>遵循教育部指定</div>
                    </el-col>
                    <el-col :span="6">
                    <div>
                        <span class="data-info  ftb">11</span>
                        <span>套</span>
                    </div>
                    <div>完备教学体系</div>
                    </el-col>
                    <el-col :span="6">
                    <div>
                        <span class="data-info  ftb">88</span>
                        <span>本</span>
                    </div>
                    <div>标准书法教材</div>
                    </el-col>
                    <el-col :span="5">
                    <div>
                        <span class="data-info  ftb">2000</span>
                        <span>+</span>
                    </div>
                    <div>涵盖3-6年级全部课程</div>
                    </el-col>
                </el-row>
                </div>
                <div class="tc mt20 pt20 mb20 pb20">
                极书既可以支持有经验老师提升教学效果，又可以满足无基础教师直接授课教学
                </div>
            </footer-nav>

    </div>
</template>

<script>
import VedioPlayerSelf from '../../components/VedioPlayerSelf'
import footerNav from '../../components/footerNav.vue'
export default {
    components: {
        VedioPlayerSelf,
        footerNav
    },
    data() {
        return{
            imgBaseAddress:this.$IMG_BASE_ADDRESS,
            defaultImg: 'this.src="' + require('../../../static/img/4.0.2/case-img05.png') + '"',
            productList: [
                {name: 'APP终端', url: '../../../static/img/4.0.2/icon-android.png', subText: ['独创七步教学法', '离线投屏上课，预装资源', '数据化评估教学效果']},
                {name: '资源平台online', url: '../../../static/img/4.0.2/icon-ie.png', subText: ['基于云服务的书法交互教育平台', '以新媒体的手段创新', '传统书法教育的内容和形式']},
                {name: '智慧教学PC终端', url: '../../../static/img/4.0.2/icon-pc.png', subText: ['多端互联，一号多用', '更高效的学习方式'], btn: '下载极书'},
                {name: '加密U盾终端', url: '../../../static/img/4.0.2/icon-usb.png', subText: ['无需安装，即插即用', '预装海量资源', '支持云平台下载课件']},
                {name: '微信公众平台', url: '../../../static/img/4.0.2/icon-wechat.png', subText: ['关注微信公众号', '在线课程学习、课程作业', '作业答疑辅导、作业记录']}
            ],
            videoList: [

            ],
            //{title: '极书宣传片', date: '2018-07-18 16:20:20', time: '00:05:07', poster: '../../../static/img/4.0.2/spface2.png', path: 'http://www.geeshu.com/admin/management/fileuploads/2021/04/geeshusite/geeshuxcp.mp4'},
            // {title: '南门小学公开课', date: '2020-03-26 10:26:50', time: '00:05:23', poster: '../../../static/img/4.0.2/spface.png', path: 'http://www.geeshu.com/admin/management/fileuploads/2021/04/geeshusite/sfk.mp4'},
            caseList:[],
        }
    },
    methods:{
        setActiveItem(i){
            this.$refs.carousel.setActiveItem(i)
        },

        info(id){
            this.$router.push({path:'/caseInfo', query: {id}})
        },

        getCaseList(){
            let _this = this;
            let param = {newsType:3,count:7};
            _this.$ajax.post('/cmsNews/findCmsNewsList',param).then((res) => {
                // res.data.forEach(function(e) {
                //     e.filePath = e.filePath.replace('.','_300x300.')
                // });
                _this.caseList = res.data;
            });
        },

        geVideoList(){
            let _this = this;
            let param = {newsType:6,count:3};
            _this.$ajax.post('/cmsNews/findCmsNewsList',param).then((res) => {
                _this.videoList = res.data;
            });
        },

        downloadExe() {
            let _this = this;
            let param = {};
            _this.$ajax.post('/download/native',param).then((res) => {
                window.location.href = _this.imgBaseAddress+res.data;
            });
        },
    },

    computed:{

    },

    created(){
        this.getCaseList();
        this.geVideoList();
    }
}
</script>

<style scoped lang="scss">
.title{
  text-align: center;
}
.title-text{
  font-size: 24px;
}
.sub-title{
  color:#999;
}
.product-list{
  display: flex;
  justify-content: space-between;
  .product-list-item{
    width: 19%;
    background: #fff;
    text-align: center;
    height: 300px;
    padding: 30px 0;
    box-sizing: border-box;
    img{
      display: inline-block;
    }
  }
}
.product-list-item:hover,.introduction:hover{
  box-shadow: 0px 0px 14px 2px #d7d7d7;
}
.downloadbtn{
  background: #ce1212;
  width: 120px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  margin: 40px auto 0;
  border-radius: 99px;
  cursor: pointer;
  font-size: 14px;
}
.introduction{
  text-align: center;
  background: #fff;
  padding: 50px 20px;
  box-sizing: border-box;
  height: 400px;
  position: relative;
  img{
    display: inline-block;
  }
  .introduction-img{
    height: 80px;
    margin-bottom: 40px;
  }
  .introduction-title{
    position: relative;
    padding-bottom:20px;
  }
  .introduction-title::after{
    position: absolute;
    content: '';
    width: 40px;
    height: 2px;
    background: #ce1212;
    bottom: 0;
    left: 50%;
    margin-left: -20px;
  }
}
.introduction::after,.introduction::before{
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  background:url('../../../static/img/4.0.2/icon-lines01.png') no-repeat center;
}
.introduction::after{
  top: 10px;
  left: 10px;
}
.introduction::before{
  bottom: 10px;
  right: 10px;
  transform: rotate(180deg);
}

.data{
  background: url('../../../static/img/4.0.2/bg.png') no-repeat center;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding:100px 0 30px;
  color:#fff;
}
.data-top{
  text-align: center;
}
.data-title{
  font-size: 24px;
  letter-spacing: 18px;
}
.data-subtitle{
  font-size: 14px;
}
.data-info{
  font-size: 70px;
}
.case{
  background: #fff;
}
.case-content{
  position: relative;
}
.case-content::after,.case-content::before{
  position: absolute;
  content: '';
  height: 30px;
  border-left: 600px solid transparent;
  border-right: 600px solid transparent;
  left: 0;
}
.case-content::before{
  border-bottom: 30px solid #fff;
  //border-left和border-right换成透明色 才能形成三角形 不然是长方形
  top: -80px;
}
.case-content::after{
  border-top: 30px solid #fff;
  //border-left和border-right换成透明色 才能形成三角形 不然是长方形
  bottom: -80px;
  left: 0;
}
.ellipsis{
width: 100%;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
.case-img{
  position: relative;
  img{
    width: 100%;
    height: 100%;
  }
  .case-img-title{
    color:#fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: rgba(0,0,0,.6);
    box-sizing: border-box;
    padding: 20px;
    display: none;
  }
}
.case-img:hover .case-img-title{
  display: block;
}
.case-img-type1{
  height: 290px;
}
.case-img-type2{
  height: 220px;
}
.case-img-type3{
  height: 173px;
}
.case-img-type4{
  height: 336px;
}
.vedio{
    background: #312d2a;
    color: #fff;
    height: 400px;
}
.video-label{
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;
}
.video-label-poster{
    width:160px;
    height: 90px;
    position: relative;
    .video-label-poster-time{
        width: 100%;
        height: 20px;
        line-height: 20px;
        background:rgba(0,0,0,.6);
        position: absolute;
        bottom: 0;
        left:  0;
        text-align: center;
    }
}
  .scrollbar {
//   width : 10px;
//   height: 10px;
//   margin: 0 auto;
  }
  ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  }
  ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(49, 45, 42, 0.2);
  background   : #535353;
  }
  ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(49, 45, 42, 0.2);
  border-radius: 10px;
  background   : #ededed;
  }

</style>



// WEBPACK FOOTER //
// src/views/components/homeIndex.vue